/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Guest } from "./Guest";
export const GuestResponse = core.serialization.object({
    data: Guest,
});
